export const TIMELINE_PAGE_SIZE = 7;

export const TELEMETRY_PAGE_SIZE = 100;

export const TEST_ID = 'applicationDetailsPage';

export const CARD_HEADER_DETAIL_TYPE = 'application';

export const DETAIL_TYPE_CLIENT = 'client';

export const DETAIL_TYPE_FARM = 'farm';

export const DETAIL_TYPE_FIELD = 'field';

export const DETAIL_TYPE_ESTIMATED_ACRES = 'estimatedAcres';

export const DETAIL_TYPE_TOTAL_VOLUME_APPLIED = 'totalVolumeApplied';

export const DETAIL_TYPE_BOUNDARY = 'boundary';

export const DETAIL_TYPE_TOTAL_AREA_APPLIED = 'totalAreaApplied';

export const DETAIL_TYPE_DRONE = 'drone';

export const DETAIL_TYPE_BATTERY = 'battery';

export const DETAIL_TYPE_PILOT = 'pilot';

export const DETAIL_TYPE_SCHEDULED_PILOT = 'scheduledPilot';

export const DETAIL_TYPE_CHEMICAL = 'chemical';
